import { useTranslation } from 'react-i18next';

const Hero = ({ eltexto, ruta, laseccion }) => {

    const { t } = useTranslation();

    var imagen = "https://ext.same-assets.com/1816929221/2705696213.jpeg";

    if (eltexto.imagen_cabecera) {
        imagen = ruta + "/" + eltexto.imagen_cabecera;
    }

    return (
        <div>
            <app-landing-section>
                <ng-component>
                    <div>
                        <div className="c-header-img">
                            <img src={imagen} alt="" />
                            <h1>{t(laseccion)}</h1>
                        </div>
                    </div>
                </ng-component>
            </app-landing-section>
        </div>
    );
}
export default Hero;
